import RouterManager from './RouterManager';

export default RouterManager;
